import type {Location} from '@github-ui/react-router'

export function generateSSOUrl(id: string, location: Location): string {
  const baseUrl = `/orgs/${encodeURIComponent(id)}/sso`
  const returnTo = location.pathname + location.search + location.hash
  return `${baseUrl}?return_to=${encodeURIComponent(returnTo)}`
}
